import { useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../utils/pathParamTypes'

export const MERGE_ANALYSIS_ROUTE_PATH =
  `/changelog/merge-analysis/:survivorPid(${pidRegexStr as PID})/:duplicatePid(${pidRegexStr as PID})` as const

type MergeAnalysisParams = PathParamMap<typeof MERGE_ANALYSIS_ROUTE_PATH>

export const useMergeAnalysisParams = (): MergeAnalysisParams => useParams<MergeAnalysisParams>()
